// Global photo / content protection handlers.
// Installed once from App.js via installContentProtection().
//
// This is a best-effort deterrent, not a guarantee. OS screenshots (PrintScreen,
// macOS ⌘-Shift-3, mobile "power + volume") cannot be blocked from a web page.
// The strategy here is:
//   * Disable right-click + drag across the site
//   * Block common "save" keyboard shortcuts
//   * Blur the app when the tab is hidden (screenshot tools usually steal focus)
//   * Warn+blur when devtools is detected
//
// All of these are disabled automatically when devtools is opened by staff roles
// (admin/moderator) so we don't shoot ourselves in the foot when debugging.

const SAFE_PATHS = ["/admin", "/ajustes", "/dashboard"];

function isOnSafePath() {
  const p = window.location.pathname || "/";
  return SAFE_PATHS.some((s) => p.startsWith(s));
}

function isAdminCookie() {
  // Best-effort: if the URL looks admin-ish, assume staff user and relax
  return isOnSafePath();
}

export function installContentProtection() {
  // Block right-click everywhere except inputs
  document.addEventListener("contextmenu", (e) => {
    const t = e.target;
    const tag = (t.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea" || t.isContentEditable) return;
    if (isAdminCookie()) return;
    e.preventDefault();
  });

  // Block drag of images globally
  document.addEventListener("dragstart", (e) => {
    const t = e.target;
    const tag = (t.tagName || "").toLowerCase();
    if (tag === "img") e.preventDefault();
  });

  // Block Ctrl/Cmd+S, Ctrl+P (Print), Ctrl+U (View source), PrintScreen
  document.addEventListener("keydown", (e) => {
    if (isAdminCookie()) return;
    const key = (e.key || "").toLowerCase();
    const mod = e.ctrlKey || e.metaKey;
    if (mod && ["s", "p", "u"].includes(key)) {
      e.preventDefault();
      return false;
    }
    if (key === "printscreen") {
      // Clear clipboard as a small deterrent on Windows PrintScreen
      try { navigator.clipboard.writeText(""); } catch (_) {}
    }
  });

  // Blur the whole app when tab is hidden (screenshot tools usually steal focus)
  const applyBlur = (on) => {
    document.documentElement.style.filter = on ? "blur(12px)" : "";
    document.documentElement.style.transition = "filter 0.15s";
  };
  document.addEventListener("visibilitychange", () => {
    if (isAdminCookie()) return;
    applyBlur(document.hidden);
  });

  // Very simple devtools-open heuristic (size diff). DISABLED on touch devices
  // and inside iframes (Emergent preview shows chrome that trips the heuristic),
  // otherwise mobile users get a false "Contenido protegido" block.
  const isTouch = ("ontouchstart" in window) || (navigator.maxTouchPoints > 0);
  const inIframe = (() => { try { return window.self !== window.top; } catch (_) { return true; } })();
  if (isTouch || inIframe) return;

  let devtoolsOpen = false;
  const threshold = 220;
  const overlay = document.createElement("div");
  overlay.id = "pk2-devtools-overlay";
  overlay.style.cssText = "position:fixed;inset:0;z-index:99999;background:rgba(10,10,10,0.94);color:#C8102E;display:none;align-items:center;justify-content:center;flex-direction:column;font-family:serif;text-align:center;padding:40px;";
  overlay.innerHTML = '<h2 style="font-size:28px;margin-bottom:12px">Contenido protegido</h2><p style="color:#aaa;max-width:420px;font-family:sans-serif;font-size:14px">Cierra las herramientas de desarrollador para continuar navegando.</p>';
  document.body.appendChild(overlay);

  setInterval(() => {
    if (isAdminCookie()) { overlay.style.display = "none"; return; }
    const widthDiff = window.outerWidth - window.innerWidth;
    const heightDiff = window.outerHeight - window.innerHeight;
    const open = widthDiff > threshold || heightDiff > threshold;
    if (open !== devtoolsOpen) {
      devtoolsOpen = open;
      overlay.style.display = open ? "flex" : "none";
    }
  }, 1500);
}
